<template>
    <div class="right-container">
        <p class="right-h2">关于Vue</p>
        <p class="right-h3">自定义标签</p>
        <p class="right-content">推荐自闭标签的写法，如下</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.vue.vue5"></code>
            </pre>
        </div>
        <p class="right-h3">避免重复</p>
        <p class="right-content">避免过多重复代码，如果超过三行类似的代码，配置数据再循环遍历</p>
        <p class="right-h3">活用v-show, v-if （不要同时出现在一个标签上）</p>
        <ul>
            <li>v-show不会改变dom树，也就是说不会导致重排。</li>
            <li>v-if会改变dom树，会导致重排。</li>
        </ul>
        <p class="right-h3">template</p>
        <p class="right-content">当我们在template里面搭建页面结构时，如果一个元素的原生属性与Vue的属性加起来超过3个时，那么就应该改变它的显示结构（如果全是原生属性就不需要）。</p>
        <p class="right-content">示例如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.vue.vue1"></code>
            </pre>
        </div>
        <p class="right-content">在通过变量来改变元素的class属性值时，不建议使用三元判断的方式来表现，应该使用对象的方式来表现（复杂情况使用计算属性或函数）。</p>
        <p class="right-content">示例如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.vue.vue2"></code>
            </pre>
        </div>
        <p class="right-h3">script</p>
        <p class="right-content">在编写Vue组件时应该按照统一的顺序来编写script下的各个属性，比如：name,comments,props,data,mounted,methods,watch,destroyed。</p>
        <div class="right-code">
            <pre>
                <code class="language-js line-numbers" v-html="code.vue.vue3"></code>
            </pre>
        </div>
        <p class="right-content">虽然这只是一个简单的顺序问题，但是一旦组件中的代码渐渐变多的时候，问题也就浮现了出来。首先就是阅读困难，当你想要阅读一段没有统一顺序的代码时，你可能得完整地阅读完所以有关script的代码，因为只有这样才能让你找到你需要的地方，但是很多地方的代码其实是可以避免去阅读降低效率的，然后就是编写困难，因为每个人的编写代码习惯不同，再加上没有统一的代码顺序，就很容易导致在修改代码的过程中造成困难，甚至引发错误。</p>
        <p class="right-content">这些其实都是可以避免的，只需要我们有一个统一的代码顺序就行了。</p>
        <p class="right-content">示例如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-js line-numbers" v-html="code.vue.vue4"></code>
            </pre>
        </div>
    </div>
</template>

<script>
import code from '../../utils/code'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
export default {
    name: "vue",
    data () {
        return {
            code: code
        }
    },
    mounted () {
        Prism.highlightAll()
    }
}
</script>

<style lang="scss" scoped>

</style>